/**
 * API client class using axios
 */
import Axios from "axios";

export class AxiosBuilder {
  _api;
  _requestHandler;
  _errorHandler;
  _requestInterceptorId;
  _responseInterceptorId;

  /**
   * @param {string} baseURL
   */
  constructor(baseURL) {
    this._api = Axios.create({ baseURL });
    this._api.builder = this;
  }

  /**
   * @return {AxiosInstance}
   */
  getApi() {
    return this._api;
  }

  /**
   * @param {string} header
   * @param {string} value
   * @returns {AxiosBuilder}
   */
  setHeader(header, value) {
    this._api.defaults.headers.common[header] = value;

    return this;
  }

  /**
   * @param {function} requestHandler
   * @return {AxiosBuilder}
   */
  setRequestHandler(requestHandler) {
    if (this._requestInterceptorId !== null) {
      this._api.interceptors.request.eject(this._requestInterceptorId);
    }

    this._requestHandler = requestHandler;

    this._requestInterceptorId = this._api.interceptors.request.use(requestHandler);

    return this;
  }

  /**
   * @param {function} errorHandler
   * @returns {AxiosBuilder}
   */
  setErrorHandler(errorHandler) {
    this._errorHandler = errorHandler;
    this._setResponseInterceptor(this._api);

    return this;
  }

  _setResponseInterceptor() {
    if (this._responseInterceptorId) {
      this._api.interceptors.response.eject(this._responseInterceptorId);
    }

    this._responseInterceptorId = this._api.interceptors.response.use(
      (response) => response,
      (error) => this._errorHandler(error)
    );
  }
}
